import React from 'react';
import Typography from '@mui/material/Typography';
import {useSelector, useDispatch} from 'react-redux';

import {selectSteps, setActiveStep} from '../redux/slices/lesson';
import CheckCircle from './icons/CheckCircle';
import ChevronRight from './icons/ChevronRight';
import Circle from './icons/Circle';
import {PENDING, IN_PROGRESS, COMPLETE} from '../constants';

import baseStyles from '../css/Base.module.css';

function renderCircle(status) {
  if (status === COMPLETE)
    return <CheckCircle className={baseStyles['m-r-5']} />;
  else return <Circle className={baseStyles['m-r-5']} />;
}

function renderStep(step, index, dispatch) {
  let containerClasses = baseStyles.row;
  if (step.status === PENDING) containerClasses += ` ${baseStyles.opacity50}`;

  let stepClasses = baseStyles['m-r-5'];
  if ([IN_PROGRESS, COMPLETE].includes(step.status))
    stepClasses += ` ${baseStyles['cursor-pointer']}`;

  return (
    <div key={`${step.name}-${index}`} className={containerClasses}>
      {renderCircle(step.status)}
      <Typography
        variant="h6"
        color="inherit"
        className={stepClasses}
        onClick={() => dispatch(setActiveStep(index))}>
        {step.name}
      </Typography>
      <ChevronRight />
    </div>
  );
}

export default function Stepper() {
  const dispatch = useDispatch();
  const steps = useSelector(selectSteps);

  return <>{steps.map((step, index) => renderStep(step, index, dispatch))}</>;
}
